<template>
  <div style="height:92%;">
      <div class="front footerPosition">
        <layout-top />
        <div class="container">
          <router-view></router-view>
        </div>
        <footer-Info />
      </div>
  </div>
</template>
<script>
import LayoutTop from '@/components/reception/public/topInfo'
import footerInfo from '@/components/reception/public/footerInfo'
export default {
  components: {
    LayoutTop,footerInfo
  }
};
</script>
<style scoped>
/* 版心 */
.container {
  width: 1200px;
  margin: auto;
}
.front {
  background: #F2F2F2;
}

</style>


// WEBPACK FOOTER //
// src/components/reception/indexCom.vue